<template>
	<button class="d-flex flex-column" @click="toggle">
		<i class="bi bi-caret-up-fill" :class="{ hidden: !topCaretVisible }" />
		<i
			class="bi bi-caret-down-fill"
			:class="{ hidden: !bottomCaretVisible }"
		/>
	</button>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
	props: {
		ascending: {
			type: Boolean as () => boolean | null,
		},
	},
	setup(props, { emit }) {
		const { ascending } = toRefs(props);
		const topCaretVisible = computed(() => ascending.value !== false);
		const bottomCaretVisible = computed(() => ascending.value !== true);

		const toggle = () => {
			if (ascending.value === null) {
				emit("toggle", false);
			} else if (ascending.value === false) {
				emit("toggle", true);
			} else {
				emit("toggle", null);
			}
		};

		return { topCaretVisible, bottomCaretVisible, toggle };
	},
});
</script>

<style scoped>
button {
	padding: 0;
	margin: 0;
	outline: none;
	border: none;
	background: none;
}

i {
	font-size: 0.6rem;
	line-height: 0.6rem;
}

.hidden {
	visibility: hidden;
}
</style>
